class CookieHandler {
    constructor(cookieName, domain) {
        this.cookieName = cookieName;
        this.domain = domain;
    }

    set(value, days) {
        let expires = "";
        let domain = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        if (this.domain)
        {
            domain = `; domain=${this.domain}`;
        }
        document.cookie = `${this.cookieName}=${value || ""}${expires}${domain}; path=/`;
    }

    get() {
        let nameEQ = this.cookieName + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    erase() {
        let domain = "";
        if (this.domain)
        {
            domain = ` domain=${this.domain};`;
        }
        document.cookie = `${this.cookieName}=;${domain} Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
}

class AgeGate {
    constructor() {
        this.cookieHandler = new CookieHandler("age_gate", window.location.hostname.includes("teremana.com") ? "teremana.com" : null);
        this.dobCookieHandler = new CookieHandler("age_gate_dob", window.location.hostname.includes("teremana.com") ? "teremana.com" : null);
        this.dob=null;
        this.ageGateSelector = "[data-age-gate]";
        this.ageGateEnterSelector = "[data-age-gate-enter]";
        this.ageGateExitSelector = "[data-age-gate-exit]";
        this.ageGateFormSelector = "[data-age-gate-form]";
        this.ageGateContinueSelector = "[data-age-gate-continue]";
        this.ageGateYearSelector = "[data-age-gate-year]";
        this.ageGateMonthSelector = "[data-age-gate-month]";
        this.ageGateDaySelector = "[data-age-gate-day]";
        this.dobLinkSelector = "[data-age-gate-dob]";
        this.months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    }

    getAge(year, month, day) {
        const current_date = new Date();
        const current_year = current_date.getFullYear();
        const current_month = current_date.getMonth() + 1;
        const current_day = current_date.getDate();

        if (current_year == year) return 0;

        if (current_month > month || (month == current_month && current_day >= day)) {
            return Math.abs(current_year - year);
        }

        return Math.abs(current_year - year - 1);
    }

    setupAgeFields(container) {

        let year = container.querySelector(this.ageGateYearSelector);
        if (year) {
            const current_date = new Date();
            const current_year = current_date.getFullYear();
            for (let i = current_year; i > current_year - 100; i--) {
                let yearOption = document.createElement("option");
                yearOption.value = i;
                yearOption.innerText = i;
                if (i == current_year)
                {
                    yearOption.selected = true;
                }
                year.appendChild(yearOption);
            }
        }

        let day = container.querySelector(this.ageGateDaySelector);
        if (day) {
            for (let i = 0; i < 31; i++) {
                let dayOption = document.createElement("option");
                dayOption.value = i + 1;
                dayOption.innerText = i + 1;
                if (i == 0)
                {
                    dayOption.selected = true;
                }
                day.appendChild(dayOption);
            }
        }

        let month = container.querySelector(this.ageGateMonthSelector);
        if (month) {
            for (let i = 0; i < this.months.length; i++) {
                const monthText = this.months[i];
                let monthOption = document.createElement("option");
                monthOption.value = i + 1;
                monthOption.innerText = monthText;
                if (i == 0)
                {
                    monthOption.selected = true;
                }
                month.appendChild(monthOption);
            }
        }

        if (year && day && month)
        {
            year.addEventListener("change", () => this.toggleEnterExit(year,month,day));
            month.addEventListener("change", () => this.toggleEnterExit(year,month,day));
            day.addEventListener("change", () => this.toggleEnterExit(year,month,day));
        }

    }

    setupForm(form) {
        form.addEventListener("submit", () => this.hideAgeGate());
    }

    showAgeGate() {
        const html = document.querySelector("html");
        html.classList.add("tm-age-gate-enabled");
        setTimeout(() => html.classList.add("tm-age-gate-visible"), 200);
    }

    hideAgeGate() {
        this.cookieHandler.set("1");
        if (this.dob)
        {
            this.dobCookieHandler.set(this.dob);
            this.setupDobLinks();
        }
        const html = document.querySelector("html");
        html.classList.remove("tm-age-gate-visible");
        setTimeout(() => html.classList.remove("tm-age-gate-enabled"), 400);
    }

    setupDobLinks() {
        let links = document.querySelectorAll(this.dobLinkSelector);
        if (links && links.length > 0)
        {
            for (let i = 0; i < links.length; i++) {
                const link = links[i];
                if (link.hasAttribute("href"))
                {
                    const url = new URL(link.getAttribute("href"));
                    url.searchParams.set("dob",this.dob);
                    link.setAttribute("href", url.toString());
                }
            }
        }
    }

    toggleEnterExit(year, month, day) {
        let proceed = false;

        if (year.value == "" || month.value == "" || day.value == "") return;

        const yearValue = parseInt(year.value);
        const monthValue = parseInt(month.value);
        const dayValue = parseInt(day.value);

        proceed = this.getAge(yearValue, monthValue, dayValue) >= 21;

        if (proceed) {
            this.dob = `${monthValue < 10 ? '0':''}${monthValue}-${dayValue < 10 ? '0':''}${dayValue}-${yearValue}`;
            if (this.ageGateExit) {
                this.ageGateExit.classList.remove("tm-age-gate-expand");
            }
            if (this.ageGateEnter) {
                this.ageGateEnter.classList.add("tm-age-gate-expand");
            }
        }
        else {
            if (this.ageGateEnter) {
                this.ageGateEnter.classList.remove("tm-age-gate-expand");
            }
            if (this.ageGateExit) {
                this.ageGateExit.classList.add("tm-age-gate-expand");
            }
        }
    }

    init() {
        this.ageGate = document.querySelector(this.ageGateSelector);
        const params = new URLSearchParams(window.location.search);

        if (params.has("ag") && params.get("ag") == "1") {
            this.cookieHandler.set("1");
        }
        if (this.ageGate && this.cookieHandler.get() != "1") {

            this.ageGateEnter = this.ageGate.querySelector(this.ageGateEnterSelector);
            this.ageGateExit = this.ageGate.querySelector(this.ageGateExitSelector);
            this.ageGateForm = this.ageGate.querySelector(this.ageGateFormSelector);
            this.ageGateContinue = this.ageGate.querySelector(this.ageGateContinueSelector);

            this.setupAgeFields(this.ageGate);

            if (this.ageGateForm) {
                this.setupForm(this.ageGateForm);
            }

            if (this.ageGateContinue) {
                this.ageGateContinue.addEventListener("click", () => this.hideAgeGate());
            }

            this.showAgeGate();
        }
        else if (this.dobCookieHandler.get())
        {
            this.dob = this.dobCookieHandler.get();
            this.setupDobLinks();
        }
    }
}

async function init() {
    const ageGate = new AgeGate();
    ageGate.init();
}

document.addEventListener('DOMContentLoaded', async () => {
    await init();
});